import { useEffect } from "react";

import { setLoginBodyOverride } from "@Components/Login/bodyOverride";
import useTranslationHook from "hooks/useTranslationHook";

import { buildSiteLoginBodyOverride } from "./siteLoginModalOverride";

/**
 * Registers the Wander-style login body for the whole global site. Whitelabel keeps the
 * legacy Login.tsx body — pass `enabled: false` there.
 */
const useGlobalSiteLoginBody = (enabled: boolean): void => {
  const { t } = useTranslationHook();

  useEffect(() => {
    if (!enabled) {
      setLoginBodyOverride(null);
      return;
    }
    setLoginBodyOverride(buildSiteLoginBodyOverride(t("Log in or sign up")));
  }, [enabled, t]);
};

export default useGlobalSiteLoginBody;
